module.exports = __webpack_public_path__ + "media/stop3.f778cabc.webm";